import {useQuery, UseQueryOptions} from '@tanstack/react-query';

import {getUserBans} from '../api';
import {QUERY__USER_BANS} from '../queryKeys';
import {UserBan} from '../types';

export const useGetUserBans = (
  userId: string,
  options?: Omit<UseQueryOptions<UserBan[]>, 'queryKey' | 'queryFn'>,
) =>
  useQuery({
    queryKey: [QUERY__USER_BANS, userId],
    queryFn: () => getUserBans(userId),
    enabled: !!userId,
    ...options,
  });
